module.exports = __webpack_public_path__ + "img/img9.985ae5ee.png";